<!--
 * @Description: 备忘录 添加
  * @Author: ZSC
 * @Date: 2023-05-09 11:00:48.154
 * @LastEditors: PF
 * @LastEditTime: 2024-06-17 14:02:36
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="70px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="标题" prop="bt" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-input v-model="ruleForm.bt" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="类型" prop="lx" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.lx" clearable filterable >
                <el-option v-for="item in bwllxData" :key="item.value" :label="item.name" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="开始时间" prop="kssj">
              <el-date-picker v-model="ruleForm.kssj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="结束时间 " prop="jssj">
              <el-date-picker v-model="ruleForm.jssj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="内容" prop="nr">
              <el-input v-model="ruleForm.nr" type="textarea" :autosize="{minRows:8}" resize="none"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow, loadSelect } from '@/api/common.js'
const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const bwllxData = ref()
watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      loadSelect({
        url: '/api/v2/bangong/beiwanglu/beiwangluleixing',
        data: bwllxData
      })
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/bangong/beiwanglu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function (res) {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
